import { getATRExtension } from 'shared/calc';

import type { PositionIndicatorHistoryState } from '../../features/positions/queries';
import { cn } from '../../lib/utils';

interface AtrExtensionValueProps {
  history: PositionIndicatorHistoryState | undefined;
}

function extensionClass(value: number): string {
  const absoluteValue = Math.abs(value);
  if (absoluteValue >= 3) return 'text-danger';
  if (absoluteValue >= 2) return 'text-warn';
  if (absoluteValue <= 1) return 'text-success';
  return 'text-text';
}

export function AtrExtensionValue({ history }: AtrExtensionValueProps) {
  if (!history || history.status === 'LOADING') {
    return <span className="text-xs text-text-muted">Loading…</span>;
  }
  if (history.status === 'ERROR') {
    return <span className="text-xs text-danger">Unavailable</span>;
  }
  if (history.status === 'INSUFFICIENT_HISTORY') {
    return (
      <span
        className="text-xs text-warn"
        title={`${history.barCount}/${history.requiredBars} required daily bars available`}
      >
        Insufficient history
      </span>
    );
  }

  const { atrExtension } = getATRExtension(history.priceData, 14, 50);
  if (!Number.isFinite(atrExtension)) {
    return <span className="text-xs text-danger">Unavailable</span>;
  }

  return (
    <span className={cn('font-medium tabular-nums', extensionClass(atrExtension))}>
      {atrExtension >= 0 ? '+' : ''}
      {atrExtension.toFixed(1)}
    </span>
  );
}
